module.exports = __webpack_public_path__ + "media/images/baranka_up-8fa50423.svg";